import {
  mapActions,
  mapGetters
} from 'vuex';
import GestionFamillesI18n from './GestionFamilles.i18n.js';

export default {

  components: {},

  props: {},

  computed: {
    ...mapGetters(['categories', 'familles', 'famillesLoading']),
    modalTitle() {
      if (this.creationMode === 'create') {
        return "Créer une nouvelle famille"
      } else {
        return "Modifier une famille"
      }
    }
  },

  data() {
    return {
      creationMode: 'create',
      currentFamilleName: '',
      currentFamilleOrder: 1,
      currentFamilleId: 0,
      currentDisplayInHome: false,
      selectedCategorie: null,
      photo: null,
      currentPhotoPreview: null
    };
  },

  watch: {},

  methods: {
    ...mapActions(['getCategories', 'getFamilles', 'createFamille', 'updateFamille', 'deleteFamille']),
    /**
     * Function to manage categories
     */
    createCurrentFamille() {
      if (this.creationMode === 'create') {
        let formData = new FormData()
        formData.append('nom', this.currentFamilleName)
        formData.append('ordre', this.currentFamilleOrder)
        if (this.currentDisplayInHome) {
          formData.append('pageAccueil', 1)
        } else {
          formData.append('pageAccueil', 0)
        }
        formData.append('photo', this.photo)
        const famille = {
          formData: formData,
          catId: this.selectedCategorie.id
        }
        this.createFamille(famille).then(res => {
          this.loadFamilles()
          this.hideModalAddFamille()
        }).catch(err => {
          console.log(err)
        })
      } else {
        let formData = new FormData()
        formData.append('nom', this.currentFamilleName)
        formData.append('ordre', this.currentFamilleOrder)
        if (this.currentDisplayInHome) {
          formData.append('pageAccueil', 1)
        } else {
          formData.append('pageAccueil', 0)
        }
        if (this.photo) {
          formData.append('photo', this.photo)
        }
        const famille = {
          formData: formData,
          catId: this.selectedCategorie.id,
          id: this.currentFamilleId
        }
        this.updateFamille(famille).then(res => {
          this.loadFamilles()
          this.hideModalAddFamille()
        }).catch(err => {
          console.log(err)
        })
      }
    },
    removeFamille() {
      const famille = {
        catId: this.selectedCategorie.id,
        id: this.currentFamilleId,
      }
      this.deleteFamille(famille).then(res => {
        console.log(res)
        this.loadFamilles()
        this.hideModalDeleteFamille()
      }).catch(err => {
        console.log(err)
      })
    },
    showModalUpdateFamille(pFamilleId, pFamilleName, pFamilleOrder, pFamilleDisplay, pFamillePreview) {
      this.currentFamilleId = pFamilleId
      this.currentFamilleName = pFamilleName
      this.currentFamilleOrder = pFamilleOrder
      if (pFamilleDisplay == 1) {
        this.currentDisplayInHome = true
      } else {
        this.currentDisplayInHome = false
      }
      this.currentPhotoPreview = pFamillePreview
      this.photo = null
      this.creationMode = 'update'
      this.$refs['modal-add-famille'].show()
    },
    showModalAddFamille() {
      this.currentFamilleId = ''
      this.currentFamilleName = ''
      this.currentFamilleOrder = 1
      this.currentDisplayInHome = false
      this.photo = null
      this.creationMode = 'create'
      this.$refs['modal-add-famille'].show()
    },
    hideModalAddFamille() {
      this.$refs['modal-add-famille'].hide()
    },
    showModalDeleteFamille(pId) {
      this.currentFamilleId = pId
      this.$refs['modal-delete-famille'].show()
    },
    hideModalDeleteFamille() {
      this.$refs['modal-delete-famille'].hide()
    },
    changeCategorie() {
      this.loadFamilles()
    },
    removePhoto() {
      this.currentPhotoPreview = null
    },
    loadFamilles() {
      this.getFamilles(this.selectedCategorie.id).then(res => {

      }).catch(err => {
        console.log(err)
      })
    },
    getPhotoLink(pPhotoLink) {
      return pPhotoLink + '?cacheKey=' + Date.now()
    }
  },

  mounted() {
    this.selectedCategorie = this.categories[0]
    this.loadFamilles()
  },

  i18n: GestionFamillesI18n,

};